var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.sended
      ? _c(
          "div",
          { staticClass: "callout form" },
          [
            _c("ValidationObserver", { ref: "contactform" }, [
              _c("div", { staticClass: "row-cols-1" }, [
                _c("div", { staticClass: "col module defaultSect" }, [
                  _c("h3", { staticClass: "titleHeader" }, [
                    _vm._v("CONTÁCTENOS"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lineDecoSection" }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (v) {
                              return [
                                _c("label", [
                                  _vm._v(
                                    "\n              Ayudenos a enviar su caso al lugar correcto\n              "
                                  ),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selected,
                                          expression: "selected",
                                        },
                                      ],
                                      class: { error: v.failed },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.selected = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          function ($event) {
                                            _vm.selected2 = null
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { domProps: { value: null } },
                                        [
                                          _vm._v(
                                            "\n                  Seleccione el tipo de solicitud...\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.contactusdata, function (c) {
                                        return _c(
                                          "option",
                                          { key: c.id, domProps: { value: c } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(c.name) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2333821390
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selected
                  ? _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("ValidationProvider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (v) {
                                  return [
                                    _c("label", [
                                      _vm._v(
                                        "\n              ¿Cómo podemos ayudarle?\n              "
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected2,
                                              expression: "selected2",
                                            },
                                          ],
                                          class: { error: v.failed },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.selected2 = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("Seleccione...")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.selected.options,
                                            function (d, idx) {
                                              return _c(
                                                "option",
                                                {
                                                  key: idx,
                                                  domProps: { value: d },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(d) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            35489606
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected2 && _vm.selected
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.validate()
                          },
                        },
                      },
                      [
                        _vm.selected.id == 7
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (v) {
                                          return [
                                            _c("label", [
                                              _vm._v(
                                                "\n                Tipo de identificación*\n                "
                                              ),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.contact.tid,
                                                      expression: "contact.tid",
                                                    },
                                                  ],
                                                  class: { error: v.failed },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        _vm.contact,
                                                        "tid",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      domProps: { value: null },
                                                    },
                                                    [_vm._v("Seleccione...")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.docTypes,
                                                    function (d, idx) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: idx,
                                                          domProps: {
                                                            value: d,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(d) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    754551852
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selected.id == 7
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (v) {
                                          return [
                                            _c("label", [
                                              _vm._v(
                                                "\n                Número de identificación*\n                "
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value: _vm.contact.id,
                                                    expression: "contact.id",
                                                    modifiers: { trim: true },
                                                  },
                                                ],
                                                class: { error: v.failed },
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: _vm.contact.id,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.contact,
                                                      "id",
                                                      $event.target.value.trim()
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.$forceUpdate()
                                                  },
                                                },
                                              }),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1083417444
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (v) {
                                      return [
                                        _c("label", [
                                          _vm._v(
                                            "\n                Nombre*\n                "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: _vm.contact.name,
                                                expression: "contact.name",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            class: { error: v.failed },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.contact.name,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.contact,
                                                  "name",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1137534524
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required|email" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (v) {
                                      return [
                                        _c("label", [
                                          _vm._v(
                                            "\n                Correo electrónico*\n                "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: _vm.contact.email,
                                                expression: "contact.email",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            class: { error: v.failed },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.contact.email,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.contact,
                                                  "email",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2007390770
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("label", [
                            _vm._v("\n              Celular\n              "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.contact.sms,
                                  expression: "contact.sms",
                                  modifiers: { trim: true },
                                },
                              ],
                              attrs: { type: "text" },
                              domProps: { value: _vm.contact.sms },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.contact,
                                    "sms",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (v) {
                                      return [
                                        _c("label", [
                                          _vm._v(
                                            "\n                Asunto*\n                "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: _vm.contact.subject,
                                                expression: "contact.subject",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            class: { error: v.failed },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.contact.subject,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.contact,
                                                  "subject",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                62054679
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (v) {
                                      return [
                                        _c("label", [
                                          _vm._v(
                                            "\n                Descripción*\n                "
                                          ),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: _vm.contact.description,
                                                expression:
                                                  "contact.description",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            class: { error: v.failed },
                                            domProps: {
                                              value: _vm.contact.description,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.contact,
                                                  "description",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "Por favor ponga los detalles de su requerimiento. Lo\n                  contactaremos tan pronto como sea posible."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.selected.id == 7
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                  Si desea adjuntar a su petición, queja, reclamo o sugerencia\n                  algún documento, por favor remitirlo al correo electrónico\n                  "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "mailto:servicioalcliente@larepublica.com.co",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "servicioalcliente@larepublica.com.co"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                  indicando en el asunto el radicado que le entregaremos al\n                  finalizar esta solicitud.\n                "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3892754154
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "col pl-0" }, [
                            _vm._v(
                              "\n              Acepta recibir información de La República a través de:\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex mt-1" }, [
                            _c("div", { staticClass: "pl-0" }, [
                              _c("label", [
                                _vm._v(
                                  "\n                  SMS\n                  "
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.contact.acceptsms,
                                      expression: "contact.acceptsms",
                                    },
                                  ],
                                  staticClass: "mt-2",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.contact.acceptsms
                                    )
                                      ? _vm._i(_vm.contact.acceptsms, null) > -1
                                      : _vm.contact.acceptsms,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.contact.acceptsms,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.contact,
                                              "acceptsms",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.contact,
                                              "acceptsms",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.contact, "acceptsms", $$c)
                                      }
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pl-0 ml-4" }, [
                              _c("label", [
                                _vm._v(
                                  "\n                  Email\n                  "
                                ),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.contact.acceptemail,
                                      expression: "contact.acceptemail",
                                    },
                                  ],
                                  staticClass: "mt-2",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.contact.acceptemail
                                    )
                                      ? _vm._i(_vm.contact.acceptemail, null) >
                                        -1
                                      : _vm.contact.acceptemail,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.contact.acceptemail,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.contact,
                                              "acceptemail",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.contact,
                                              "acceptemail",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.contact,
                                          "acceptemail",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col terminosCondiones mb-4 mt-3" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                rules: { required: { allowFalse: false } },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (v) {
                                      return [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.contact.acceptterms,
                                                expression:
                                                  "contact.acceptterms",
                                              },
                                            ],
                                            class: { error: v.failed },
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.contact.acceptterms
                                              )
                                                ? _vm._i(
                                                    _vm.contact.acceptterms,
                                                    null
                                                  ) > -1
                                                : _vm.contact.acceptterms,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.contact.acceptterms,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.contact,
                                                        "acceptterms",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.contact,
                                                        "acceptterms",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.contact,
                                                    "acceptterms",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(
                                            "\n                Acepto los\n                "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                rel: "noopener",
                                                href: _vm.urlDisclaimer,
                                              },
                                            },
                                            [_vm._v("Términos y condiciones")]
                                          ),
                                          _vm._v(
                                            "\n                y conozco la\n                "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                rel: "noopener",
                                                href: _vm.urlPrivacy,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Política de tratamiento de información"
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3298858282
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.loading
                          ? _c("div", { staticClass: "col-2" }, [
                              _c("button", { staticClass: "button" }, [
                                _vm._v("Enviar"),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.sendingError
                          ? _c("div", { staticClass: "col sending-error" }, [
                              _vm._v(
                                "\n            Ocurrió un error al enviar los datos, por favor intente de nuevo.\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loading
                          ? _c("div", { staticClass: "col" }, [
                              _vm._v("Enviando..."),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "g-recaptcha",
                          attrs: {
                            id: "recaptcha",
                            "data-sitekey": _vm.recaptchaKey,
                            "data-callback": "sendForm",
                            "data-size": "invisible",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sended ? _c("div", { staticClass: "row" }, [_vm._m(0)]) : _vm._e(),
    _vm._v(" "),
    _vm.sended
      ? _c("div", { staticClass: "row" }, [
          !_vm.pqrId
            ? _c("div", { staticClass: "col sendText" }, [
                _vm._v(
                  "\n      Su solicitud ha sido recibida. Nuestro equipo atendera su caso a la mayor\n      brevedad.\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pqrId
            ? _c("div", { staticClass: "col sendText pqrResult" }, [
                _c("p", [
                  _vm._v(
                    "\n        Su solicitud ha sido recibida con éxito, se envió copia del registro a\n        su correo electrónico.\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("Detalle del registro:")]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v("\n          Radicado:\n          "),
                    _c("b", [_vm._v(_vm._s(_vm.pqrId))]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("\n          Fecha:\n          "),
                    _c("b", [_vm._v(_vm._s(_vm.createDate))]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("\n          Hora:\n          "),
                    _c("b", [_vm._v(_vm._s(_vm.createTime))]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col module news genericSect" }, [
      _c("h3", { staticClass: "titleHeader" }, [
        _vm._v("GRACIAS POR CONTACTARNOS"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lineDecoSection" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }